import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { InputBox, Password } from "../../components/CustomWidgets/InputBox";
import "react-phone-number-input/style.css";
// import SelectBox from "../CustomWidgets/SelectBox";
import { Button, Input, Table, Modal } from "antd";
import "../../styles.css";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { UpdateRetailerDetails } from "../../API  Functions/ProfileFunctions";
import LoadingSpinner from "../Loading";
import { checkPermission } from "../../Utils/permissionHelper";
import { getStoreUsers } from "../../API  Functions/UserMangement";
import { toast } from "react-toastify";
import { Trash2 } from "lucide-react"; // delete icon
import UpdatedProfile from "../../modals/UpdatedProfile";
import * as Yup from "yup";
import SelectBox, { MultiSelectBox } from "../CustomWidgets/SelectBox";
import { Tooltip, IconButton } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Select } from "antd";

const { Option } = Select;



const UserAccessSettings = ({
  retailerDetails,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);

  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
const [dailySales, setDailySales] = useState({
  restrict_cost_price: false,
  master_password: '',
});
console.log("restrict_cost_price==>",retailerDetails);
// console.log("master_password==>",retailerDetails?.retailer_details?.master_password);

useEffect(() => {
  if (retailerDetails) {
    setDailySales({
      restrict_cost_price:
        retailerDetails?.restrict_cost_price || false,
      master_password:
        retailerDetails?.master_password ?? ''
    });
  }
}, [retailerDetails]);


const handleDailySalesToggle = () => {
  setDailySales((prev) => ({
    ...prev,
    restrict_cost_price: !prev.restrict_cost_price,
  }));
};

console.log("dailySales-->",dailySales);


const onSubmit = async()=>{
    // console.log("master_password====>",dailySales.master_password);
    
    if(dailySales.restrict_cost_price && (!dailySales.master_password || dailySales.master_password?.length < 1)){
        toast.error(t("Please enter password"))
        return;
    }
    try{
        setLoading(true);
const finalPayload = {
      user_id: user_id,
  restrict_cost_price: dailySales.restrict_cost_price,
  master_password: dailySales.master_password,
};

        const response = await UpdateRetailerDetails(finalPayload);
        if (response?.status === "Update Successfully") {
         toast.success(t('Updated Successfully'))
        }
    }catch (err){
console.error("submit error", err);
    }finally{
        setLoading(false);

    }

}

  const filteredOptions = users
          .map((item) => ({
            value: item.user_id,
            label: `${item.name} (${item.email ? item.email : item?.phone})`,
          }));
  return (
    <>
      {loading && <LoadingSpinner />}
<div className="bg-white rounded-lg p-5 mt-5 shadow-sm border">
  <h3 className="text-lg font-semibold mb-4">
    {t("Password required for updating quantity or prices")}
  </h3>

  {/* Toggle */}
  <div className="flex items-center justify-between mb-4">
    <p className="text-sm font-medium">
      {t("Enable Password")}
    </p>

    <label className="flex cursor-pointer select-none items-center">
      <div className="relative">
        <input
          type="checkbox"
          checked={dailySales.restrict_cost_price}
          onChange={handleDailySalesToggle}
          className="sr-only"
        />

        <div
          className={`block h-6 w-12 rounded-full ${
            dailySales.restrict_cost_price
              ? "bg-green-500"
              : "bg-gray-500"
          }`}
        ></div>

        <div
          className={`absolute left-1 top-1 flex h-4 w-5 items-center justify-center rounded-full bg-white transition ${
            dailySales.restrict_cost_price
              ? "translate-x-full"
              : ""
          }`}
        ></div>
      </div>
    </label>
  </div>

  {/* Multi Select */}
  {dailySales.restrict_cost_price && (
    
        <Password
                              name="inventory_password"
                              show={0}
                              placeholder={t("Enter Password")}
                              value={dailySales.master_password}
    onChange={(e) => {
      setDailySales((prev) => ({
        ...prev,
        master_password: e.target.value,
      }));
    }}
                            />
  )}
  
</div>
  <div className="flex justify-end gap-5  mt-8 mb-10 ">
          <button
            // disabled={!isChanged}
            onClick={onSubmit}
            className={`w-[180px] h-[45px] rounded-lg font-semibold bg-primaryBlue text-white
            
            `}
          >
            {t("Update & Save")}
          </button>
        </div>
 </>
  );
};

export default UserAccessSettings;
